import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { pick } from '../../util/common';
import {
  createStripeAccount,
  updateStripeAccount,
  fetchStripeAccount,
} from '../../ducks/stripeConnectAccount.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Async thunks ================ //

const savePayoutDetailsPayloadCreator = (
  { values, isUpdateCall },
  { dispatch, rejectWithValue }
) => {
  const upsertThunk = isUpdateCall ? updateStripeAccount : createStripeAccount;

  return dispatch(upsertThunk(values, { expand: true }))
    .then(response => response)
    .catch(() => rejectWithValue('Failed to save payout details'));
};

export const savePayoutDetailsThunk = createAsyncThunk(
  'SellerPayoutSetupPage/savePayoutDetails',
  savePayoutDetailsPayloadCreator
);

export const savePayoutDetails = (values, isUpdateCall) => dispatch =>
  dispatch(savePayoutDetailsThunk({ values, isUpdateCall })).unwrap();

// ================ Slice ================ //

const initialState = {
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaved: false,
};

const sellerPayoutSetupPageSlice = createSlice({
  name: 'SellerPayoutSetupPage',
  initialState,
  reducers: {
    setInitialValues: (state, action) => {
      return { ...initialState, ...pick(action.payload, Object.keys(initialState)) };
    },
    clearPayoutDetailsSaved: state => {
      state.payoutDetailsSaved = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(savePayoutDetailsThunk.pending, state => {
        state.payoutDetailsSaveInProgress = true;
        state.payoutDetailsSaved = false;
      })
      .addCase(savePayoutDetailsThunk.fulfilled, state => {
        state.payoutDetailsSaveInProgress = false;
        state.payoutDetailsSaved = true;
      })
      .addCase(savePayoutDetailsThunk.rejected, state => {
        state.payoutDetailsSaveInProgress = false;
      });
  },
});

export const { setInitialValues, clearPayoutDetailsSaved } = sellerPayoutSetupPageSlice.actions;
export default sellerPayoutSetupPageSlice.reducer;

// ================ Load Data ================ //

export const loadData = () => (dispatch, getState) => {
  dispatch(setInitialValues());

  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(() => {
    const currentUser = getState().user.currentUser;
    if (currentUser && currentUser.stripeAccount) {
      dispatch(fetchStripeAccount());
    }
  });
};
